<template>
  <div v-if="!isChatPreloader" style="text-align:center">
    <svg
      :style="{ width, height }"
      class="circular-loader"
      width="100%"
      height="100%"
      viewBox="0 0 42 42"
    >
      <circle
        cx="21"
        cy="21"
        r="18.2"
        fill="#E0E0E0"
        stroke="#E0E0E0"
        stroke-width="0.2"
      ></circle>
      <circle
        cx="21"
        cy="21"
        r="13.6"
        :fill="background"
        stroke="#E0E0E0"
        stroke-width="0.2"
      ></circle>
      <circle cx="21" cy="21" r="15.91549430918954" fill="transparent"></circle>
      <circle
        :class="['loader-path', { 'with-color': color }]"
        cx="21"
        cy="21"
        r="15.91549430918954"
        fill="transparent"
        stroke="currentColor"
        stroke-width="4.5"
      ></circle>
    </svg>
  </div>

  <!-- Иконка для чата -->
  <svg v-else class="circular-loader" :style="{ width, height }" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM1.96649 7C1.96649 9.77993 4.22007 12.0335 7 12.0335C9.77993 12.0335 12.0335 9.77993 12.0335 7C12.0335 4.22007 9.77993 1.96649 7 1.96649C4.22007 1.96649 1.96649 4.22007 1.96649 7Z" fill="#E0E0E0"/>
    <path d="M13.0168 7C13.5598 7 14.0071 7.44235 13.9311 7.98003C13.7984 8.9179 13.4763 9.82262 12.9806 10.6377C12.3138 11.7339 11.3585 12.6258 10.2192 13.2158C9.07986 13.8059 7.80026 14.0715 6.5202 13.9835C5.24014 13.8956 4.00888 13.4575 2.96094 12.7172C1.913 11.9768 1.08871 10.9627 0.578121 9.78558C0.0675334 8.60847 -0.109704 7.31367 0.0657741 6.04265C0.241252 4.77163 0.762695 3.57329 1.57313 2.57857C2.17571 1.83896 2.92081 1.23307 3.76047 0.794721C4.24185 0.543411 4.80823 0.817206 4.98967 1.32903C5.17111 1.84085 4.89618 2.3951 4.42931 2.67244C3.92367 2.9728 3.47236 3.36079 3.09768 3.82067C2.51492 4.53595 2.13997 5.39764 2.01378 6.3116C1.8876 7.22555 2.01505 8.15661 2.3822 9.00304C2.74935 9.84947 3.34208 10.5787 4.09562 11.1111C4.84916 11.6434 5.73453 11.9584 6.65499 12.0217C7.57544 12.0849 8.49557 11.8939 9.31485 11.4696C10.1341 11.0453 10.821 10.404 11.3005 9.61576C11.6087 9.10896 11.8236 8.55395 11.9378 7.97702C12.0432 7.44432 12.4737 7 13.0168 7Z" fill="url(#paint0_linear_1036_86)"/>
    <defs>
      <linearGradient id="paint0_linear_1036_86" x1="8.34343" y1="-1.37204e-07" x2="0.848485" y2="14" gradientUnits="userSpaceOnUse">
        <stop stop-color="#58B6A9"/>
        <stop offset="1" stop-color="#4A86AF"/>
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: '80px'
    },
    height: {
      type: String,
      default: '80px'
    },
    background: {
      type: String,
      default: '#ffffff'
    },
    color: {
      type: Boolean,
      default: true
    },
    isChatPreloader: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/system/_vars";
@import "../../assets/css/system/_mixins";

.circular-loader {
  -webkit-animation: rotate 2s linear infinite;
  animation: rotate 2s linear infinite;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
  transform-origin: center center;
  margin: auto;
}

.loader-path {
  stroke-dasharray: 150, 200;
  stroke-dashoffset: -10;
  -webkit-animation: dash 1.2s ease-in-out infinite,
    color 6s ease-in-out infinite;
  animation: dash 1.2s ease-in-out infinite;
  stroke-linecap: round;

  &.with-color {
    animation: dash 1.2s ease-in-out infinite, color 6s ease-in-out infinite;;
  }
}

@-webkit-keyframes rotate {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes rotate {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-webkit-keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -20;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -94;
  }
}
@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -20;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -94;
  }
}
@-webkit-keyframes color {
  0% {
    stroke: #7d0e7f;
  }
  40% {
    stroke: #cf1285;
  }
  66% {
    stroke: #7d0e7f;
  }
  80%,
  90% {
    stroke: #cf1285;
  }
}
@keyframes color {
  0% {
    stroke: #7d0e7f;
  }
  40% {
    stroke: #cf1285;
  }
  66% {
    stroke: #7d0e7f;
  }
  80%,
  90% {
    stroke: #cf1285;
  }
}
</style>
